import {
  HTTP_GETPROJECT_FETCHING,
  HTTP_GETPROJECT_SUCCESS,
  HTTP_GETPROJECT_FAILED,
  server,
  OK,
  YES,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";

export const setStateProjectToFetching = () => ({
  type: HTTP_GETPROJECT_FETCHING,
});

export const setStateProjectToSuccess = (payload) => ({
  type: HTTP_GETPROJECT_SUCCESS,
  payload,
});

export const setStateProjectToFailed = (payload) => ({
  type: HTTP_GETPROJECT_FAILED,
});

export const clearProject = () => {
  return async (dispatch) => {
    dispatch(setStateProjectToSuccess([]));
  };
};

export const getProject = (sid) => {
  return async (dispatch) => {
    dispatch(setStateProjectToFetching());
    try {
      const result = await httpClient.get(`${server.GETPROJECT_URL}/${sid}`, {
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      dispatch(setStateProjectToSuccess(result.data));
    } catch (error) {
      dispatch(setStateProjectToFailed());
    }
  };
};
